import * as React from 'react';

const SvgRatingSad = (props) => React.createElement(
  "svg",
  Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props),
  React.createElement("path", { fill: "#2D2E2E", d: "M8.5 11.25a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5ZM15.5 11.25a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5Z" }),
  React.createElement("path", { fill: "#2D2E2E", d: "M12 2C6.49 2 2 6.49 2 12s4.49 10 10 10 10-4.49 10-10S17.51 2 12 2Zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8Z" }),
  React.createElement("path", { fill: "#2D2E2E", d: "M12 13c-2.12 0-4.1 1.15-5.18 3.01l1.73 1C9.28 15.75 10.57 15 12 15c1.43 0 2.72.75 3.45 2.01l1.73-1C16.1 14.15 14.12 13 12 13Z" })
);

export { SvgRatingSad as default };
//# sourceMappingURL=RatingSad.es.js.map
